import React from 'react';
import Button from './Button';

interface OldGameBannerProps {
  oldGameDate?: Date;
  onStartLatestGame: () => void;
  isLoading?: boolean;
}

const OldGameBanner: React.FC<OldGameBannerProps> = ({
  oldGameDate,
  onStartLatestGame,
  isLoading = false,
}) => {
  const formatDate = (date: Date) => {
    return date.toLocaleDateString('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric'
    });
  };

  return (
    <div className="bg-yellow-50 border-b border-yellow-200 px-4 py-3">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <svg className="w-5 h-5 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
          <div className="ml-3">
            <p className="text-sm text-yellow-800">
              <span className="font-medium">You are on an old game</span>
              {oldGameDate && (
                <span className="ml-1">from {formatDate(oldGameDate)}</span>
              )}
            </p>
          </div>
        </div>
        <div className="flex-shrink-0">
          <Button
            onClick={onStartLatestGame}
            variant="primary"
            size="small"
            disabled={isLoading}
            className="bg-yellow-600 hover:bg-yellow-700 text-white text-sm px-3 py-1"
          >
            {isLoading ? 'Starting...' : 'Start Latest Game'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default OldGameBanner;